import React, { useState, useEffect, useContext, useMemo } from "react";
import "./services.scss";
import axios from "axios";
import Category from "../../common/category";
import { useParams } from "react-router-dom";
import Breadcrumbs from "../../common/breadcumb";
import Loading from "../../common/loading";
import Errors from "../../common/error";
import { LangContext } from "../../context/LangContext";
function List() {
  const { state } = useContext(LangContext);
  const nep = state.np;
  const { slug } = useParams();
  const [service, setService] = useState(null);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const API_URL = `${process.env.REACT_APP_URL}service/detail/${slug}`;
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(false);
      try {
        const response = await axios.get(API_URL);
        const detail = response.data.detail;
        const categoryData = response.data.category;
        setService(detail);
        setCategory(categoryData);
      } catch (err) {
        console.error("Error fetching service details:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  const mainData = useMemo(() => {
    if (!service) return null;
    return nep ? service.ne : service.en;
  }, [service, nep]);
  const mainDataCat = useMemo(() => {
    if (!category) return [];
    return nep ? category.ne : category.en;
  }, [category, nep]);

  const pageTitle = useMemo(() => {
    switch (slug) {
      case "internet-banking":
        return nep ? "इन्टरनेट बैंकिङ" : "Internet Banking";
      case "top-up-facilities":
        return nep ? "टप अप सुविधा" : "Top Up Facilities";
      case "nchl-services":
        return nep ? "एनसीएचएल सेवाहरू" : "NCHL Services";
      case "remittance":
        return nep ? "रेमिटेन्स" : "Remittance";
      case "safe-deposit-locker":
        return nep ? "सुरक्षित डिपोजिट लकर" : "Safe Deposit Locker";
      case "c-asba":
        return nep ? "C-ASBA" : "C-ASBA";
      case "depository-participant":
        return nep ? "डिपोजिटरी पार्टिसिपेन्ट" : "Depository Participant";
      case "guheswori-debit-card":
        return nep ? "गुहेश्वरी डेबिट कार्ड" : "Guheswori Debit Card";
      case "guheswori-smart-app":
        return nep ? "गुहेश्वरी स्मार्ट एप" : "Guheswori Smart App";
      case "gmbf-sms-alert":
        return nep ? "गुहेश्वरी एसएमएस अलर्ट" : "GMBF SMS Alert";
      case "rtgs":
        return nep ? "आरटिजिएस" : "RTGS";
      default:
        return slug;
    }
  }, [slug, nep]);

  if (loading) return <Loading />;
  if (error) return <Errors />;

  return (
    <>
      <Breadcrumbs PageTitle={pageTitle} />
      <main className="InsidePageContainer">
        <div className="wrapper">
          <div className="InsideFlexBox">
            <div className="services-body">
              <div
                className="CKContentBOX"
                dangerouslySetInnerHTML={{
                  __html: mainData?.description || "",
                }}
              />
            </div>
            <div className="service-aside">
              <h3>{nep ? "सम्बन्धित सेवाहरू" : "Related Services"}</h3>
              <ul>
                {mainDataCat.map((cat) => (
                  <Category key={cat.id} cat={cat} url={`../services/`} />
                ))}
              </ul>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default List;
